import React from 'react';
import './description.style.scss';

type TRoleDescriptionProps = {
    children : React.ReactNode,
   title? : string
}
const RoleDescription = ({children, title} : TRoleDescriptionProps) => {
  return (
    <>
      <p className="shop-roles-description">
        <span className="shop-roles-description-title">{title}</span>
        {children}
      </p>
    </>
  );
};

export default RoleDescription;
